// Honest, user-facing release highlights. Shared by the profile Release Notes modal,
// the Events tab, and the public landing "What's New" section.
export const RELEASE_NOTES = [
  {
    version: "v4.1 · System Version 1.0.0 — V1 Link Pack Engine",
    date: "Aug 2026",
    items: [
      "New unified plans: Free, Plus ($4.95/mo), Pro ($9.95/mo, Most Popular), and Gold ($14.95/mo) — all with 2 months free on yearly billing.",
      "Link Packs now split into Always Active (Daily, Gas), Trend packs (Trending Finds, Collectibles, Gaming, Bags & Style, Tech Deals), and Retailer packs (Walmart, Temu, Fashion Nova).",
      "Home now shows up to 3 packs at a time — Daily, Gas, and one rotating top Trend pack.",
      "Tier reveal caps: Free 1 pack/day (4 cards), Plus 2 packs/day (6 cards), Pro 4 packs/day (10 cards), Gold 8 packs/day (12 cards).",
      "Pack opening is now a true mystery reveal — cards fan out face-down and you tap each one to flip it, with a safe Back button that never costs you your daily pack.",
    ],
  },
  {
    version: "v4.0 · Introducing Price Slip",
    date: "Aug 2026",
    items: [
      "The app is now Price Slip — a daily trading-card game for real price drops, gold/amber foil and all.",
      "Open a free Daily Drop pack every 24 hours, or unlock store boosters (Walmart, Temu, Fashion Nova, Tech) on a paid plan.",
      "Swipe right to Save a card to My Collection, swipe left to Pass — desktop gets on-screen buttons + arrow keys.",
      "Every card shows your exact Est. Total with local tax, MSRP, discount %, and rarity (COMMON / RARE / LEGENDARY).",
      "The old Paste-A-Link checker lives on as \"Inspect a Link\" — tap the floating button to open it anytime.",
    ],
  },

  {
    version: "v0.8 · Clearer Reads & Guides",
    date: "Aug 2026",
    items: [
      "Standardized status cards — every one of the 7 categories now shows a single clean LOW / AVERAGE / HIGH market read with a plain-English recommendation.",
      "New in-app platform guide plays right in the hero, plus a mobile add-to-home-screen guide inside the sign-in screen — no leaving the app.",
      "Refreshed showcase with clearer headlines and a caption on every feature preview.",
      "Smarter link pasting — tracking junk (ref, utm, pd_rd, content-id…) is stripped automatically and much longer links are supported.",
    ],
  },
  {
    version: "v0.7 · Live Market View",
    date: "Aug 2026",
    items: [
      "You now launch straight into the Live Market View — no extra dashboard hop.",
      "New \"Today's Read\" conversational engine: a plain-English, 2-sentence summary of each market versus yesterday (with a statewide-average fallback).",
      "Daily allowance meter shows exactly how many item searches & link analyses you have left today.",
      "Paid members get a searchable 50-state market picker to switch the state they're viewing.",
      "Cleaner mobile flow: tools tucked into a slide-out drawer, categories in a top chip bar.",
    ],
  },
  {
    version: "v0.6 · Categories & Alerts",
    date: "Aug 2026",
    items: [
      "Standardized market cards for Gas & EV, Electric & Water, Housing, Cars, Groceries, Tech and Subscriptions.",
      "Category-aware price alerts with a 1–5 day window and an in-app alerts inbox — no email required.",
      "Real nearby gas stations pulled live for your state (pump prices shown as estimates).",
    ],
  },
  {
    version: "v0.5 · Plans",
    date: "Aug 2026",
    items: [
      "Simple subscription plans (Standard, VIP Silver, VIP Gold) with a Monthly / Annually toggle.",
      "Credits retired — one clean plan unlocks everything in your tier, with daily usage allowances.",
    ],
  },
];
